import { useState } from "react";
import { Visibility } from "@mui/icons-material";
import { Grid, Typography, InputAdornment, IconButton } from "@mui/material";

import { Paper, TextField, Label } from "../../components";
import {
  PrimaryLoadingButton,
  CancelButton,
} from "../../pages/css components/Button";
import { useNavigate } from "react-router-dom";

export default function FormDisplay({ formikProps }) {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState(false);

  return (
    <Paper style={{ width: "600px", padding: "50px" }}>
      <Grid item xs={12}>
        <Typography variant="h2">Change Password</Typography>
      </Grid>

      <Grid item xs={6}>
        <Label
          title={"Old Password"}
          formikProps={formikProps}
          required={true}
          name={"oldPassword"}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          required
          type={showPassword ? "text" : "password"}
          name="oldPassword"
          formikProps={formikProps}
          inputProps={{ "aria-label": "Without label" }}
          placeholder="Old password"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  style={{ padding: 0 }}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <Visibility />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <Label
          title={"New Password"}
          formikProps={formikProps}
          required={true}
          name={"newPassword"}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          required
          type={confirmPassword ? "text" : "password"}
          name="newPassword"
          inputProps={{ "aria-label": "Without label" }}
          placeholder="New Password"
          formikProps={formikProps}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  style={{ padding: 0 }}
                  onClick={() => setConfirmPassword(!confirmPassword)}
                >
                  <Visibility />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <Label
          title={"Confirm Password"}
          formikProps={formikProps}
          required={true}
          name={"confirmPassword"}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          required
          type={confirmPassword ? "text" : "password"}
          name="confirmPassword"
          inputProps={{ "aria-label": "Without label" }}
          placeholder="Confirm Password"
          formikProps={formikProps}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  style={{ padding: 0 }}
                  onClick={() => setConfirmPassword(!confirmPassword)}
                >
                  <Visibility />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      <Grid item xs />

      <Grid item>
        <CancelButton onClick={() => navigate(-1)} variant="outlined">
          Cancel
        </CancelButton>
      </Grid>

      <Grid item textAlign={"end"}>
        <PrimaryLoadingButton
          type="submit"
          variant="contained"
          fullWidth
          onClick={formikProps.handleSubmit}
          disabled={!formikProps.isValid}
          loading={formikProps.isSubmitting}
        >
          Submit
        </PrimaryLoadingButton>
      </Grid>
    </Paper>
  );
}
